// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Tooltip, IconButton, Icon } from '@material-ui/core';
import { GridOverlay, GridToolbar } from '@material-ui/data-grid';
import { DataTable, EmptyState } from '../../../../common/components';
import { DateUtils, StringUtils } from '../../../../common/utils';
import { useAlert } from '../../../../common/hooks';
import { AlertSeverity } from '../../../../common/providers';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    '& .MuiDataGrid-root': {
      border: '0',
      '& .MuiDataGrid-row': {
        '& .MuiIconButton-root': {
          display: 'none',
        },
        '&:hover .MuiIconButton-root': {
          display: 'inline-flex',
        },
      },
    },
  },
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 'auto',
  },
}));

function EventsTab(props) {
  const [t] = useTranslation();
  const { showAlert } = useAlert();
  const classes = useStyles();

  const { data } = props;

  const getEventType = params => {
    const userEventType = params.value;
    if (!userEventType) {
      return '';
    }
    if (!userEventType.displayText) {
      return `${userEventType.eventSubTypeDescription} - ${userEventType.eventTypeDescription}`;
    }
    return userEventType.displayText;
  };

  const handleCopyEventText = async eventText => {
    await navigator.clipboard.writeText(eventText);
    showAlert({
      title: t('common.success'),
      message: t('event.eventTextCopySuccess'),
      severity: AlertSeverity.Success,
    });
  };

  const renderEventText = params => {
    const eventText = params.value;
    if (eventText) {
      return (
        <>
          <Box className={classes.text}>{eventText}</Box>
          {navigator.clipboard && (
            <Tooltip title={t('event.eventTextCopy')}>
              <IconButton
                aria-label="copyToClipboard"
                onClick={() => handleCopyEventText(eventText)}
              >
                <Icon>content_copy</Icon>
              </IconButton>
            </Tooltip>
          )}
        </>
      );
    }
    return null;
  };

  const getColumnDefs = () => [
    {
      field: 'created',
      headerName: t('event.eventCreated'),
      width: 200,
      type: 'dateTime',
      valueFormatter: params => DateUtils.getDateTime(params.value),
    },
    {
      field: 'orderId',
      headerName: t('event.eventOrderId'),
      width: 150,
    },
    {
      field: 'productId',
      headerName: t('event.eventProductId'),
      width: 150,
    },
    {
      field: 'creator',
      headerName: t('event.eventCreator'),
      width: 200,
    },
    {
      field: 'userEventType',
      headerName: t('event.eventType'),
      width: 250,
      flex: 0.75,
      valueGetter: getEventType,
      sortComparator: StringUtils.compare,
    },
    {
      field: 'eventText',
      headerName: t('event.eventText'),
      width: 300,
      flex: 1,
      renderCell: renderEventText,
    },
  ];

  const getRowData = () =>
    data.map((event, index) => ({
      ...event,
      id: index,
    }));

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('event.eventsEmpty')} />
    </GridOverlay>
  );

  return (
    <Box id="EventsTab-container" className={classes.container}>
      <DataTable
        id="EventsTab-table"
        components={{
          Toolbar: GridToolbar,
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        pageSize={20}
        paginationMode="client"
        pagination
      />
    </Box>
  );
}

EventsTab.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default EventsTab;
